import { render, staticRenderFns } from "./FolderRelaunchDialog.vue?vue&type=template&id=31eb24b2&scoped=true"
import script from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
export * from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderRelaunchDialog.vue?vue&type=style&index=0&id=31eb24b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eb24b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCheckbox,VProgressCircular})
